import React from 'react'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup"
import axios from 'axios';
import Swal from 'sweetalert2'


const initialValues = {
  email: "",
}
const SubscribeSection = () => {
  const formik = useFormik({
    initialValues: initialValues,

    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Email is required').matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, "Please Enter a Valid Email."),
    }),
    onSubmit: (values, { resetForm }) => {
      // console.log(values)
      let timerInterval
      Swal.fire({
        title: 'Please Wait...',
        html: 'Your subscription is processing...',
        timer: 10000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
          // const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            //   b.textContent = Swal.getTimerLeft()
          }, 100)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          // console.log('I was closed by the timer')
        }
      })
      // axios.post('http://localhost:1995/post-subscribed-email', values)
      // axios.post('https://tapi.alobhatech.com/post-subscribed-email', values)
      axios.post('https://www.alobhaapi.alobhatech.com/post-subscribed-email', values)
        .then(function (response) {
          // console.log(response)
          if (response.status == 200) {
            // console.log(`Success`)
            Swal.fire(
              'Thank you contacting us .',
              'You have been subscribed successfully',
              'success'
            )
            // toast.success("Thank you subscribing us . We will revert back to your query soon. ");
            resetForm();
          } else if (response.status == 201) {
            Swal.fire(
              'You are already subscribed.',
              'Thankyou for contacting.',
              'success'
            )
            // toast.success("Thank you subscribing us . We will revert back to your query soon. ");
            resetForm();
          } else {
            Swal.fire(
              'Please try again.',
              'Something went wrong',
              'error'
            )
          }
        })
        .catch(function (error) {
          Swal.fire(
            'Server Error, Please try again later.',
            'Something went wrong',
            'error'
          )
          console.log(error.response)
          // toast.warn(error.response.data.Message);

        })


    }
  });
  return (
    <div>
      <section className="bg-img text-center newsletter">
        <div className="container">
          <h2 className='fontkumbh'>
            {/* <strong>Newsletter</strong> */}
            Newsletter
          </h2>
          <h6 className="font-alt fontkumbh">Get all updates to your inbox</h6>
          <br />
          {/* <form class="form-subscribe" action="#"> */}
          <form onSubmit={formik.handleSubmit} className="form-subscribe" id="newsMyform" method="POST" encType="multipart/form-data"
          >
            <div className="input-group">
              <input type="email" name="email" className="form-control input-lg" placeholder="Your email address"
                required="" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} />

              <span className="input-group-btn">
                <button type="submit" name="submit" value="SUBMIT" className="btn btn-success btn-lg subs-btn" id="loderButton4" >
                  <i className="fa fa-spinner fa-pulse fa-fw" id="loderIcon4" style={{ display: "none" }} />
                  Subscribe
                </button>
              </span>
            </div>
            <div className="help-block with-errors text-left pl-4">
              {formik.touched.email && formik.errors.email ? (
                <div className='text-danger'>*{formik.errors.email}</div>
              ) : null}
            </div>

          </form>
        </div>
      </section>

    </div>
  )
}

export default SubscribeSection